import React from 'react';

const Logo: React.FC = () => {
  return (
    <div className="logo">
      <img className='logo-img' src="logo.png" alt="Define Constraints" />
    </div>
  );
};

export default Logo; 